import { createAction, props } from '@ngrx/store';
import { CertificatesModel } from '@models/certificates.model';

export const resetToInitialState = createAction('[CERTIFICATE] Reset to Initial state');

export const beforeGetCertificates = createAction(
  '[CERTIFICATE] Before Get Certificates',
  props<{
    filters: CertificatesModel.RequestFilter;
  }>(),
);

export const getCertificates = createAction(
  '[CERTIFICATE] Get Certificates',
  props<{
    filters: CertificatesModel.RequestFilter;
  }>(),
);
export const getCertificatesSuccess = createAction(
  '[CERTIFICATE] Get Certificates Success',
  props<{
    documents: CertificatesModel.Document[];
    page: string;
    limit: number;
  }>(),
);
export const getCertificatesLogsFail = createAction('[CERTIFICATE] Get Certificates Fail');

export const setCertificatesLoader = createAction(
  '[CERTIFICATE] Set Certificates loader',
  props<{
    loading: boolean;
  }>(),
);
